<template>
    <div>
        <b-card :title="$t('Component(SentRequestViewRequest):information')" class="mb-0">
            <div>
                {{ $t('Component(SentRequestViewRequest):information-description', {supplier: request.supplier.title}) }}
            </div>
        </b-card>

        <b-card no-body>
            <div class="card-header">
                <div class="col-md-6 pl-0">
                    <b-card-title>
                        {{ $t('Component(SentRequestViewRequest):customer-product-information') }}
                    </b-card-title>
                </div>
            </div>
            <table class="table">
                <thead>
                    <th>{{ $t('Component(SentRequestViewRequest):supplier') }}</th>
                    <th>{{ $t('Component(SentRequestViewRequest):supplier-contact') }}</th>
                    <th>{{ $t('Component(SentRequestViewRequest):supplier-email') }}</th>
                    <th>{{ $t('Component(SentRequestViewRequest):product') }}</th>
                    <th>{{ $t('Component(SentRequestViewRequest):product-id') }}</th>
                    <th>{{ $t('Component(SentRequestViewRequest):request-deadline') }}</th>
                </thead>
                <tbody>
                    <tr>
                        <td>{{ request.supplier.title }}</td>
                        <td>{{ request.supplier.contact.name }}</td>
                        <td>{{ request.supplier.contact.communicationChannels[0].details }}</td>
                        <td>{{ productName }}</td>
                        <td>{{ productId }}</td>
                        <td>{{ request.validTo|moment('Y-MM-DD') }}</td>
                    </tr>
                </tbody>
            </table>
        </b-card>

        <b-row>
            <b-col md="6" lg="4">
                <InformationRequested :request="request" />
            </b-col>
            <b-col md="6" lg="8">
                <Conversation key="sent-request-view-request" :request-id="request.id" />
            </b-col>
        </b-row>
    </div>
</template>
<script>
import InformationRequested from "@/views/request/components/InformationRequested";
import {Conversation} from "@core/components/messenger";
import { BCard, BCardTitle, BListGroup, BListGroupItem, BRow, BCol } from 'bootstrap-vue'
import {getSupplierIdentifier, getSupplierName} from "@/libs/product";

export default {
    components: {
        BCard,
        BCardTitle,
        BListGroup, BListGroupItem,
        BRow, BCol,
        Conversation,
        InformationRequested,
    },
    props: {
        request: {
            type: Object,
            required: true
        },
    },
    computed: {
        productName() {
            if (this.request.product.names.length === 0) {
                return '';
            }
            return getSupplierName(this.request.product) || this.request.product.names[0].value
        },
        productId() {
            if (this.request.product.identifiers.length === 0) {
                return '';
            }

            return getSupplierIdentifier(this.request.product) || this.request.product.identifiers[0].value;
        }
    }
}
</script>
